export const DRAFTS_NAMESPACE = 'drafts';
